/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';

/**
 * Emission Event serializer used for partial update operations.
 * @export
 * @interface PatchedEmissionEventPartialUpdateRequest
 */
export interface PatchedEmissionEventPartialUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedEmissionEventPartialUpdateRequest
     */
    responsible?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEmissionEventPartialUpdateRequest
     */
    notifyResponsible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedEmissionEventPartialUpdateRequest
     */
    reviewer?: number | null;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof PatchedEmissionEventPartialUpdateRequest
     */
    eventStatus?: EventStatusEnum;
}



/**
 * Check if a given object implements the PatchedEmissionEventPartialUpdateRequest interface.
 */
export function instanceOfPatchedEmissionEventPartialUpdateRequest(value: object): value is PatchedEmissionEventPartialUpdateRequest {
    return true;
}

export function PatchedEmissionEventPartialUpdateRequestFromJSON(json: any): PatchedEmissionEventPartialUpdateRequest {
    return PatchedEmissionEventPartialUpdateRequestFromJSONTyped(json, false);
}

export function PatchedEmissionEventPartialUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedEmissionEventPartialUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'notifyResponsible': json['notify_responsible'] == null ? undefined : json['notify_responsible'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'eventStatus': json['event_status'] == null ? undefined : EventStatusEnumFromJSON(json['event_status']),
    };
}

export function PatchedEmissionEventPartialUpdateRequestToJSON(json: any): PatchedEmissionEventPartialUpdateRequest {
    return PatchedEmissionEventPartialUpdateRequestToJSONTyped(json, false);
}

export function PatchedEmissionEventPartialUpdateRequestToJSONTyped(value?: PatchedEmissionEventPartialUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'responsible': value['responsible'],
        'notify_responsible': value['notifyResponsible'],
        'reviewer': value['reviewer'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
    };
}

